function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useReducer } from "react";
import { node } from "prop-types";
import { HIDE_DROPDOWN_MENU, SET_DROPDOWN_MENU, SET_TRIGGER_BUTTON, SHOW_DROPDOWN_MENU, SET_DROPDOWN_MENU_POSITION } from "#library/components/Dropdown/Dropdown.actions";
export var initialState = {
  isDropdownMenuVisible: false,
  dropdownMenu: null,
  dropdownMenuRef: null,
  triggerButton: {
    height: 0,
    top: 0,
    width: 0
  }
};
var DropdownContext = /*#__PURE__*/createContext();
var dropdownReducer = function dropdownReducer(state, action) {
  switch (action.type) {
    case SHOW_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDropdownMenuVisible: true
      });
    case SET_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        dropdownMenu: action.payload.dropdownMenu
      });
    case SET_TRIGGER_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        triggerButton: action.payload.triggerButton
      });
    case HIDE_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDropdownMenuVisible: false
      });
    case SET_DROPDOWN_MENU_POSITION:
      return _objectSpread(_objectSpread({}, state), {}, {
        dropdownMenuPosition: action.payload.position
      });
    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
};
export var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(dropdownReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var value = {
    state: state,
    dispatch: dispatch
  };
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: value
  }, children);
};
DropdownProvider.propTypes = {
  children: node.isRequired
};
export var useDropdown = function useDropdown() {
  var context = useContext(DropdownContext);
  if (context === undefined) {
    throw new Error("`useDropdown` must be used within a `DropdownProvider`");
  }
  return context;
};